import { CommonService } from "../../../../../services/CommonService";
import YearsOFExperience from "../../components/YearsOfExperience";
import { order } from "../SmartSearchParammeter";

export default async function YearOfExperienceSearchConfig(key) {
  let yearsOfExperience = await CommonService.getAllYearsExperience();
  return {
    description: "Years of Experience",
    id: "yearsOfExperienceOptions",
    initial: [],
    type: order.first,
    Component: (searchObject, setSearchObject, onChange, t) => (
      <div className="col-6 mt-2">
        <YearsOFExperience
          searchObject={searchObject}
          setSearchObject={setSearchObject}
          t={t}
        />
      </div>
    ),
    handleValues: (searchObject) => {
      searchObject.yearsOfExperienceOptions =
        searchObject.yearsOfExperienceOptions.map;
    },
    operation: ["Must"],
    list: yearsOfExperience.map((y) => y.description.replace(/,/g, "#")),
    examples: [
      `Natural Language: "I want a developer with 5 years of experience\nStructured Query: "${key} Must 5 years"`
    ],
    handler: function (searchObj, value) {
      let selected = yearsOfExperience.filter((y) =>
        value.includes(y.description.replace(/,/g, "#"))
      );
      searchObj["yearsOfExperienceOptions"] = selected;
    }
  };
}
